export default __webpack_public_path__ + "static/media/813.9f4831ab.gif";